import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule, CurrencyPipe, DecimalPipe } from '@angular/common';
import { WeissmanSharedModule } from '../Common/weissman-shared.module';
import { ParcelIconModule } from '../Entity/Parcel/Icon/parcelIcon.module';
import { HybridAdapterUtility } from '../Hybrid/hybrid-adapter.utility';
import { TeamModule } from '../Team/team.module';
import { CompleteFileAppealModalComponent } from './Complete-File-Appeal-Modal/completeFileAppealModal.component';
import { DocumentProcessingModule } from './Documents/documentProcessing.module';
import { ChangeDueDateModalComponent } from './change-due-date.modal.component';
import { ProcessAppealWarrantedComponent } from './Process-Appeal-Warranted-Modal/processAppealWarranted.component';
import { ProcessNoAppealComponent } from './Process-No-Appeal-Modal/processNoAppeal.component';
import { RetrievalStatusModalService } from './RetrievalStatus/retrieval-status-modal.service';
import { ModalModule } from 'ngx-bootstrap/modal';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { Constants } from '../constants.new';
import { SharedPipesModule } from '../UI-Lib/Pipes/shared-pipes.module';
import { ProcessInvoiceComponent } from './Invoice/invoice.component';
import { InvoiceDetailsComponent } from './Invoice/Invoice-Details/invoiceDetails.component';
import { InvoiceService } from './Invoice/invoice.service';
import { InvoiceRecipientLookupComponent } from '../Common/Contracts-Invoices/invoice-recipient-lookup.component';
import { SetDocumentRetrievalStatusModalComponent } from './RetrievalStatus/set-document-retrieval-status.modal.component';
import { TypeaheadModule } from 'ngx-bootstrap/typeahead';
import { RetrievalStatusService } from './RetrievalStatus/retrieval-status.service';
import { FeeAllocationComponent } from './Invoice/Fee-Allocation/fee-allocation.component';
import { AgGridExtensionsModule } from '../Compliance/AgGrid/agGridExtensions.module';
import { AgGridModule } from 'ag-grid-angular';
import { RevenueShareGridActionCellRendererComponent } from './Invoice/Fee-Allocation/agGridActionCellRendererComponent';
import { AgGridCostCenterCellRendererComponent } from './Invoice/Fee-Allocation/agGridCostCenterCellRenderer';
import { AgGridEngagementNumberCellRendererComponent } from './Invoice/Fee-Allocation/agGridEngagementNumberCellRenderer';
import { AgGridExpenseAmountCellRendererComponent } from './Invoice/Fee-Allocation/agGridExpenseAmountCellRenderer';
import { AgGridPercentAllocationCellRendererComponent } from './Invoice/Fee-Allocation/agGridPercentAllocationCellRenderer';
import { TransmittalModule } from './Transmittal/transmittal.module';
import { InvoicePanelComponent } from './Invoice/invoice-panel.component';
import { InvoiceDetailsTotalsComponent } from './Invoice/Invoice-Old/Details/invoice-details-totals.component';
import { CurrencyMaskModule } from '../UI-Lib/Currency/Mask/currencyMask.module';
import { ProcessInvoiceOldComponent } from './Invoice/Invoice-Old/invoice.component';
import { InvoiceRedirectComponent } from './Invoice/invoiceRedirect.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        WeissmanSharedModule,
        TransmittalModule,
        SharedPipesModule,
        ModalModule,
        PopoverModule,
        TooltipModule,
        TypeaheadModule,
        CurrencyMaskModule,
        AgGridExtensionsModule,
        TeamModule,
        ParcelIconModule,
        DocumentProcessingModule,
        AgGridModule,

        // Standalone Components
        InvoicePanelComponent,
        ProcessInvoiceComponent,
        ProcessInvoiceOldComponent,
        InvoiceRedirectComponent,
        FeeAllocationComponent,
        InvoiceDetailsComponent,
        InvoiceRecipientLookupComponent,
        InvoiceDetailsTotalsComponent,
    ],
    declarations: [
        ChangeDueDateModalComponent,
        SetDocumentRetrievalStatusModalComponent,
        RevenueShareGridActionCellRendererComponent,
        AgGridCostCenterCellRendererComponent,
        AgGridEngagementNumberCellRendererComponent,
        AgGridExpenseAmountCellRendererComponent,
        AgGridPercentAllocationCellRendererComponent,
        ProcessAppealWarrantedComponent,
        ProcessNoAppealComponent,
        CompleteFileAppealModalComponent,
    ],
    providers: [
        RetrievalStatusModalService,
        RetrievalStatusService,
        Constants,
        InvoiceService,
        DecimalPipe,
        CurrencyPipe,
    ],
    exports: [InvoicePanelComponent],
})
export class ProcessingModule {
    static setupModule(): void {
        TransmittalModule.setupModule();
        DocumentProcessingModule.setupModule();

        const hybridAdapterUtility = new HybridAdapterUtility();

        hybridAdapterUtility.downgradeNg2Provider('retrievalStatusModalService', RetrievalStatusModalService);
        // Angular 2+ components we're making available for AngularJS
        hybridAdapterUtility.downgradeNg2Component('changeDueDateModal', ChangeDueDateModalComponent);
        hybridAdapterUtility.downgradeNg2Component('invoice', ProcessInvoiceComponent);
        hybridAdapterUtility.downgradeNg2Component('invoicePanel', InvoicePanelComponent);
    }
}
